import { Button, Col, Modal, Row } from "antd";
import { User } from "authing-js-sdk";
import React, { FC, useCallback, useState } from "react";
import { BindEmail } from "./BindEmail";
import { BindPhone } from "./BindPhone";
import styles from "./styles.module.less";
import { UpdateEmail } from "./UpdateEmail";
import { UpdatePhone } from "./UpdatePhone";
import { useTranslation } from "react-i18next";
import { ConfigCard } from "@/components/ConfigCard";
import { IconFont } from "@/components/IconFont";
import classNames from "classnames";
import { useMediaSize } from "@/hooks/useMediaSize";
import { RightOutlined } from "@ant-design/icons";

export const UserPageConnection: FC = () => {
  const [user, setUser] = useState(window.__user__);
  const { t } = useTranslation();
  const updateUser = (user: User) => {
    setUser(user);
    window.__user__ = user;
  };

  const { isPhoneMedia } = useMediaSize();

  const [bindPhoneVisible, setBindPhoneVisible] = useState(false);
  const [updatePhoneVisible, setUpdatePhoneVisible] = useState(false);
  const renderBindPhone = () => (
    <BindPhone
      visible={bindPhoneVisible}
      onOk={(user) => {
        setBindPhoneVisible(false);
        updateUser(user);
      }}
      onCancel={() => setBindPhoneVisible(false)}
    />
  );
  const renderUpdatePhone = () =>
    user && (
      <UpdatePhone
        user={user}
        visible={updatePhoneVisible}
        onOk={(user) => {
          setUpdatePhoneVisible(false);
          updateUser(user);
        }}
        onCancel={() => setUpdatePhoneVisible(false)}
      />
    );

  const [bindEmailVisible, setBindEmailVisible] = useState(false);
  const [updateEmailVisible, setUpdateEmailVisible] = useState(false);
  const renderBindEmail = () => (
    <BindEmail
      visible={bindEmailVisible}
      onOk={(user) => {
        setBindEmailVisible(false);
        updateUser(user);
      }}
      onCancel={() => setBindEmailVisible(false)}
    />
  );
  const renderUpdateEmail = () =>
    user && (
      <UpdateEmail
        user={user}
        visible={updateEmailVisible}
        onOk={(user) => {
          setUpdateEmailVisible(false);
          updateUser(user);
        }}
        onCancel={() => setUpdateEmailVisible(false)}
      />
    );

  const items = [
    {
      key: "email",
      label: t("common.email"),
      value: user?.email,
      icon: "authing-youxiang",
      onBind: () => setBindEmailVisible(true),
      onUpdate: () => setUpdateEmailVisible(true),
      onUnbind: () =>
        Modal.confirm({
          title: t("login.confirmUnbindEmail"),
          okCancel: true,
          onOk: async () => {
            const user = await window.__authing__.unbindEmail();
            updateUser(user);
          },
        }),
    },
    {
      key: "phone",
      label: t("common.phoneNumber"),
      value: user?.phone,
      icon: "authing-phone",
      onBind: () => setBindPhoneVisible(true),
      onUpdate: () => setUpdatePhoneVisible(true),
      onUnbind: () =>
        Modal.confirm({
          title: t("login.confirmUnbinPhont"),
          okCancel: true,
          onOk: async () => {
            const user = await window.__authing__.unbindPhone();
            updateUser(user);
          },
        }),
    },
  ];

  const defAction = useCallback(
    (item: any) =>
      item.value ? (
        <>
          {item.onUnbind && (
            <Button
              icon={<IconFont type="authing-link-unlink" style={{ fontSize: 16, marginRight: 6, color: "#FA6400" }} />}
              type="link"
              onClick={item.onUnbind}
              style={{
                color: "#333",
              }}
            >
              {t("login.releaseBind")}
            </Button>
          )}

          <Button
            icon={<IconFont type="authing-bianji1" style={{ fontSize: 16, marginRight: 6 }} />}
            type="link"
            onClick={item.onUpdate}
          >
            {t("common.modify")}
          </Button>
        </>
      ) : (
        <Button
          icon={<IconFont type="authing-link1" style={{ fontSize: 16, marginRight: 6 }} />}
          type="link"
          onClick={item.onBind}
        >
          {t("common.bind")}
        </Button>
      ),

    [t]
  );

  const mediaAction = useCallback(
    (item) => (
      <div className={styles.action}>
        {item.value ? <span className={styles.value}>{item.value}</span> : <span>{t("user.unBind")}</span>}
        <RightOutlined />
      </div>
    ),
    [t]
  );

  const mediaOnClick = useCallback((item) => (item.value ? item.onUpdate : item.onBind), []);

  return (
    <ConfigCard title={t("login.accBind")} extra={null}>
      <div className={styles.connection}>
        {renderBindPhone()}
        {renderUpdatePhone()}
        {renderBindEmail()}
        {renderUpdateEmail()}

        <Row>
          {items.map((item) => (
            <Col key={item.key} span={24} className={styles.row} onClick={isPhoneMedia && mediaOnClick(item)}>
              {/* <Icon icon={item.key} active={!!item.value} /> */}
              <div
                className={classNames(styles.iconContent, {
                  [styles.active]: !!item.value,
                })}
              >
                <IconFont type={item.icon} />
              </div>
              <span className={styles.label}>{item.label}</span>
              {!isPhoneMedia && (
                <>
                  {item.value && ":"}
                  <span className={styles.value}>{item.value}</span>
                </>
              )}

              <div style={{ flex: 1 }}></div>
              {!isPhoneMedia ? defAction(item) : mediaAction(item)}
            </Col>
          ))}
        </Row>
      </div>
    </ConfigCard>
  );
};
